export enum ApiAccountKeyKeys {
    Id = "apiAccountKeyId",
    PublicKey= "publicKey",
    Created = "createDate",
    Descriptor = "descriptor",
    ExpiryDate = "expiryDate"
  }

export enum ApiAccountKeyTableKeys {
  PublicKey= "publicKey",
  Created = "createDate",
  Descriptor = "descriptor",
  ExpiryDate = "expiryDate"
}
  

export interface ApiAccountKey {
    [ApiAccountKeyKeys.Id]:string,
    [ApiAccountKeyKeys.PublicKey]: string,
    [ApiAccountKeyKeys.Created]: string,
    [ApiAccountKeyKeys.Descriptor]: string,
    [ApiAccountKeyKeys.ExpiryDate]: string
  }
  
export interface ApiAccountKeyCreateRequest {
  apiAccountId: string,
  expiryDate: string,
  descriptor: string
}

export interface ApiAccountKeyCreateResponse {
  token: string;
}